import React, { Component } from 'react';
import { connect } from 'react-redux'
import {
    Button, Modal, ModalHeader, ModalBody, ModalFooter, Input
} from 'reactstrap';
import TableView from '../Table/index'
//import setcorporateModal from '../CreateScorecardModal/index'
import { setSearchCorporateParameterScorecard, setcorporateModal } from '../action'
class CreateScorecardModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            search: ""
        }
    }
    toggleModalCreate = () => {

    }

    onhandleChange = (e) => {
        this.setState({ search: e.target.value,
               })
               
        
    }
    search = () => {
        this.props.setSearchCorporateParameterScorecard("name", this.state.search);
    }

    render() {
        let disabled=true
        if(this.state.search)
        {
          disabled=false
        }
        return (
            <Modal isOpen={this.props.corporateModal} toggle={this.props.setcorporateModal} className={this.props.className} size="lg" >
                <ModalHeader toggle={this.corporateModal}>Select {this.props.modalType}<i className="icon-close cursor-pointer" onClick={this.props.setcorporateModal}></i></ModalHeader>
                <ModalBody className="p-0">
                    <div>
                        <div className="px-4 mb-4">
                            <div className="row">
                                <div className="col-22">
                                    <Input type="text" name="search" id="search" placeholder={this.searchPlaceholder} onChange={(e) => this.onhandleChange(e)} />
                                </div>
                                <div className="col-2">
                                    <div className="text-right">
                                        <Button color="primary" className="p-1 mt-1" outline onClick={this.search} disabled={disabled}>
                                            <i className="icon-search"></i>
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <TableView selectedCounterparty={(selected) => this.props.onSelectCounterparty(selected)} />
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button className="btn btn-primary" onClick={this.props.setcorporateModal}>Done</button>
                </ModalFooter>
            </Modal>
        )
    }
}
const mapStateToProps = (state, ownProps) => ({
    corporateModal: state.createScorecard.corporateModal,

})
const mapDispatchToProps = (dispatch) => ({
    setcorporateModal: (value) => { dispatch(setcorporateModal(value)) },//setSearchCorporateParameter
    setSearchCorporateParameterScorecard: (param, value) => { dispatch(setSearchCorporateParameterScorecard(param, value)) }
});
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CreateScorecardModal);
// export default CreateScorecardModal;
